import { LocalStorageService } from './../../services/local-storage.service';
import { Router } from '@angular/router';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  public routes = {
    ADMINISTRATOR: '/administrateurs',
    UFA_AND_TRAINING: '/ufa',
    BUSINESS_CARD: '/fiche-metier',
    LEARNING_OFFERS: '/offres-d-apprentissage',
    FAQ: '/faq',
    NEWS: '/actualites',
    POLES: '/poles',
    EMPLOYERS_OPINIONS: '/avis-employeurs',
  };
  @Input() activeRoute = '';
  @Output() IsClicked = new EventEmitter<string>();
  @Output() Clicked = new EventEmitter<string>();
  @Input() value;
  public userId: string;

  private ufaRoutes = [
    'ufa',
    'modifier-ufa',
    'ajouter-ufa',
    'formations',
    'creer-formation',
    'modifier-formation',
  ];
  private newsRoutes = ['actualites', 'modifier-actualite', 'creer-actualite'];
  private businessCard = ['fiche-metier'];
  private adminRoutes = [
    'administrateurs',
    'modifier-administrateur',
    'ajouter-administrateur',
  ];
  private faqRoutes = ['faq', 'ajouter-faq', 'modfier-faq'];
  private employersOpinionsRoutes = [
    'avis-employeurs',
    'ajouter-avis-employeur',
    'modfier-avis-employeur',
  ];
  private poleRoutes = ['poles', 'ajouter-pole', 'modfier-pole'];
  private learningOffersRoutes = ['offres-d-apprentissage', 'ajouter-offre-d-apprentissage', 'modfier-offre-d-apprentissage'];

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.userId = this.localStorageService.getCurrentUser().id;
    this.checkCurrentRoute();
  }

  checkCurrentRoute() {
    var urlFields = this.router.url.split('/')[1];
    if (this.newsRoutes.includes(urlFields)) {
      this.activeRoute = 'NEWS';
    } else if (this.ufaRoutes.includes(urlFields)) {
      this.activeRoute = 'UFA_AND_TRAINING';
    } else if (this.businessCard.includes(urlFields)) {
      this.activeRoute = 'BUSINESS_CARD';
    } else if (this.adminRoutes.includes(urlFields)) {
      this.activeRoute = 'ADMINISTRATOR';
    } else if (this.faqRoutes.includes(urlFields)) {
      this.activeRoute = 'FAQ';
    } else if (this.poleRoutes.includes(urlFields)) {
      this.activeRoute = 'POLES';
    } else if (this.employersOpinionsRoutes.includes(urlFields)) {
      this.activeRoute = 'EMPLOYERS_OPINIONS';
    } else if (this.learningOffersRoutes.includes(urlFields)) {
      this.activeRoute = 'LEARNING_OFFERS';
    }
  }

  onClick($event, $url): void {
    console.log('VALUE ', this.activeRoute, $event);
    this.activeRoute = $event;
    this.checkCurrentRoute();
    Object.entries(this.routes).forEach((route) => {
      if (route[1] === $url) {
        this.activeRoute = route[0];
      }
    });
    this.router.navigate([this.routes[$event]]);
    this.IsClicked.emit(this.activeRoute);
    this.Clicked.emit(this.activeRoute);
  }

  closeMenu(): void {
    this.IsClicked.emit(this.activeRoute);
  }
}
